"use client";

import { getPaginationItems } from "@/lib/helpers";
import { TObituaryList } from "@/types/obituary";
import { useRouter } from "next/navigation";

type Props = {
  type: string;
};

const ObituaryPagination = ({
  page,
  total,
  totalPages,
  term,
  type,
}: TObituaryList & Props) => {
  const values = getPaginationItems(page, totalPages - 1);

  const router = useRouter();

  const handlerClick = (selectedPage: number) => {
    if (type === "search") {
      router.push(`/traueranzeigen/search/${term}/${selectedPage}`);
    } else if (type === "list") {
      router.push(`/traueranzeigen/${selectedPage}`);
    }
  };

  return (
    <div className="flex w-full flex-row items-center justify-center gap-1">
      {page === 0 ? (
        <div className="flex h-10 w-10 items-center justify-center rounded-md border border-secondary-300 bg-secondary-100 text-secondary-300">
          <svg
            width="14"
            height="20"
            viewBox="0 0 14 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className=" h-2 w-2 rotate-180 stroke-current text-secondary-500"
          >
            <path
              d="M2 23.2059L11.5536 12.7582L2 2.31054"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      ) : (
        <button
          onClick={() => {
            handlerClick(page - 1);
          }}
          id="pagination-prev"
          className="flex h-10 w-10 items-center justify-center rounded-md border border-secondary-600 bg-secondary-100 text-secondary transition-all duration-300 hover:bg-secondary-200"
        >
          <svg
            width="14"
            height="20"
            viewBox="0 0 14 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className=" h-2 w-2 rotate-180 stroke-current text-secondary"
          >
            <path
              d="M2 23.2059L11.5536 12.7582L2 2.31054"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
      {values.map((value) => (
        <>
          {value === page ? (
            <div
              id="actual-page"
              className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary text-white"
            >
              {value + 1}
            </div>
          ) : (
            <button
              onClick={() => {
                handlerClick(value);
              }}
              id={`pagination-${value + 1}`}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-secondary-600 bg-secondary-100 text-secondary  transition-all duration-300 hover:bg-secondary-200"
            >
              {value + 1}
            </button>
          )}
        </>
      ))}
      {page === totalPages - 1 ? (
        <div className="flex h-10 w-10 items-center justify-center rounded-md border border-secondary-300 bg-secondary-100 text-secondary-300 ">
          <svg
            width="14"
            height="20"
            viewBox="0 0 14 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className=" h-2 w-2 stroke-current text-secondary-300"
          >
            <path
              d="M2 23.2059L11.5536 12.7582L2 2.31054"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      ) : (
        <button
          onClick={() => {
            handlerClick(page + 1);
          }}
          id="pagination-next"
          className="flex h-10 w-10 items-center justify-center rounded-md border border-secondary-600 bg-secondary-100 text-secondary transition-all duration-300 hover:bg-secondary-200"
        >
          <svg
            width="14"
            height="20"
            viewBox="0 0 14 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className=" h-2 w-2 stroke-current text-secondary"
          >
            <path
              d="M2 23.2059L11.5536 12.7582L2 2.31054"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default ObituaryPagination;
